import { useCallback } from "react";

import { useRequest } from "@/hooks/use-request/use-request";

interface UserInfoResponse {
  id: number;
  referralCode: string;
}

export function useRegister() {
  const { request } = useRequest();

  return useCallback(
    (userAddress: string) => {
      return request<UserInfoResponse>("users/by-user-address", {
        method: "POST",
        body: JSON.stringify({
          userAddress,
        }),
      });
    },
    [request],
  );
}
